import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'

export default (permission: string): boolean => {
  const authStore = useAuthStore()
  const { user } = storeToRefs(authStore)
  const userPermissions = user.value?.permissions

  return !!(userPermissions && userPermissions.includes(permission))
}
